import React, {Component} from 'react';
import './Slider.css';
import PropTypes from 'prop-types';

export default class Slider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeImage: null,
            previousImage: null,
            stateComparison: null
        };

        this.anyActiveRendered = false;
    }

    // -----------------------------------------------------------------------------------------------------------------

    componentWillMount() {
        // this.componentWillReceiveProps(this.props, null);
        this.restartCycleTimer();
    }

    componentWillUnmount() {
        this.clearCycleTimer();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let stateComparison = JSON.stringify(nextProps.images);

        // NB: State comparison helps prevent "jumps" back to the first image.
        // Basically, if the image set is the same (compared via JSON string), don't automatically change the position.

        // ...unless, for reasons I don't understand, we're not rendering any images(???).
        // this bug happens with sub questions only, so the `anyActiveRendered` flag works around this.

        if (stateComparison !== this.state.stateComparison || !this.anyActiveRendered) {
            this.setState({
                activeImage: (this.props.images.length > 0 ? this.props.images[0] : null),
                previousImage: null,
                stateComparison: stateComparison
            });
        }
    }

    // -----------------------------------------------------------------------------------------------------------------

    clearCycleTimer() {
        if (this.cycleInterval) {
            clearInterval(this.cycleInterval);
            this.cycleInterval = null;
        }
    }

    restartCycleTimer() {
        this.clearCycleTimer();

        if (!this.props.images || this.props.images.length <= 1) {
            return;
        }

        this.cycleInterval = setInterval(this.cycleTick.bind(this), Slider.CYCLE_INTERVAL_MS);
    }

    cycleTick() {
        this.restartCycleTimer();

        let findNext = false;
        let nextImg = null;
        let previousImage = null;

        this.props.images.forEach((img) => {
            let isActive = this.state.activeImage === img;

            if (isActive) {
                previousImage = img;
                findNext = true;
            } else if (findNext) {
                nextImg = img;
                findNext = false;
            }
        });

        if (!nextImg) {
            nextImg = this.props.images[0];
        }

        this.setState({
            activeImage: nextImg,
            previousImage: previousImage
        });
    }

    // -----------------------------------------------------------------------------------------------------------------

    handleMouseMove() {
        this.restartCycleTimer();
    }

    handleDotClick(img) {
        if (img && this.state.activeImage !== img) {
            this.setState({
                activeImage: img,
                previousImage: this.state.activeImage
            });
        }

        this.restartCycleTimer();
    }

    // -----------------------------------------------------------------------------------------------------------------

    renderSlide(img, forPrevious) {
        let imgClassNames = ["slide"];

        let isActive = this.state.activeImage === img;
        let hasPrev = this.state.previousImage;
        let isPrev = hasPrev && !isActive && this.state.previousImage === img;

        if (isActive) {
            imgClassNames.push("active");

            if (hasPrev) {
                imgClassNames.push("next");
            }

            this.anyActiveRendered = true;
        }

        if (isPrev) {
            imgClassNames.push("prev");

            if (!forPrevious) {
                return (null);
            }
        }

        return <img className={imgClassNames.join(' ')} src={img.src} alt={img.text} key={`slide-${img.src}`}/>;
    }

    render() {
        if (!this.props.images) {
            return (null);
        }

        let classNames = ["Slider"];

        let prevImg = (null);

        this.anyActiveRendered = false;

        return (
            <div className={classNames.join(' ')}>
                {this.props.images.length > 1 &&
                <div className={"dots"}>
                    {this.props.images.map((img) => {
                        let dotClassNames = ["dot"];
                        let isActive = this.state.activeImage === img;

                        if (isActive) {
                            dotClassNames.push("active");
                        }

                        return <a className={dotClassNames.join(' ')} key={`dot-${img.src}`}
                                  onClick={this.handleDotClick.bind(this, img)}><div className={"inner"}/></a>
                    })}
                </div>
                }
                <div className={"slides"} onMouseMove={this.handleMouseMove.bind(this)}>
                    {this.state.previousImage &&
                    this.renderSlide(this.state.previousImage, true)}

                    {this.props.images.map((img) => {
                        return this.renderSlide(img, false);
                    })}
                </div>
            </div>
        );
    }

    // -----------------------------------------------------------------------------------------------------------------
}

Slider.CYCLE_INTERVAL_MS = 3500;

Slider.propTypes = {
    images: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/Portal/Slider/Slider.js